'use strict';/* global define:false */define('modules/objectives/states/team_objectives/controller',[],function(){'use strict';// @ngInject
function controller($scope,Objective){// jshint validthis:true
// jshint latedef:false
var vm=this;vm.orderBy='-open';// vm.orderByOptions = {
//   name    : 'lastname',
//   open    : [
//     '-objectiveStatistics.open',
//     '+objectiveStatistics.total'
//   ],
//   overdue : [
//     '-objectiveStatistics.overdue',
//     '+objectiveStatistics.total'
//   ]
// };
vm.toggleOrderReverse=toggleOrderReverse;$scope.supervisees=Objective.supervisees();function toggleOrderReverse(){vm.orderReverse=!vm.orderReverse;}}controller.$inject = ["$scope", "Objective"];return controller;});
